<template>
    <div class="btn-caption">
        <router-link tag="button"
                     class="waves-effect waves-light btn-large brand-font"
                     :to="{ name: 'lander', params: { slug: slug }}"
        >Proceed...</router-link>
        <span>{{ caption }}</span>
    </div>
</template>
<script>
  export default {
    props: ['slug', 'caption']
  }
</script>